<template>
  <vs-prompt buttons-hidden	class="large" :title="data.id ? 'تعديل مادة دراسية' : 'إضافة مادة دراسية'"
            @close="close"
            :active="active">

    <h4 class="mb-3">قم بادخال بيانات المادة</h4>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          <vs-input label-placeholder="رمز المادة" name="id" data-vv-as="هذا الحقل" v-validate="'required|alpha_num|min:2'" v-model="formData.id" class="w-full" />
          <span class="text-danger text-sm" v-show="errors.has('id')">{{ errors.first('id') }}</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-input label-placeholder="اسم المادة" name="name" data-vv-as="هذا الحقل" v-validate="'required|min:2'" v-model="formData.name" class="w-full" />
          <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <vs-textarea label="الوصف" counter="500" name="desc" :rows="6" v-model="formData.description" class="mb-4 w-full" />
        </div>
      </div>
    <vs-divider />
    <div class="flex justify-end">
      <vs-button @click="close" class="mx-5" type="flat">رجوع</vs-button>
      <vs-button @click="submitClicked">حفظ</vs-button>
    </div>
  </vs-prompt>
</template>

<script>
    import coursesAPI from '@/api/admin/coursesAPI'

    export default {
        name: 'course-form',
        props: {
            data: {
                required: true,
                type: Object
            },
            active: {
                required: true,
                default: false,
                type: Boolean
            }
        },
        watch: {
            active(val){
                if(!val) return

                this.intiValues()
                Object.assign(this.formData, this.data)
            }
        },
        data () {
            return {
                formData:{
                    id: '',
                    name: '',
                    description: '',
                },
            }
        },
        methods: {
            submitClicked(){
                this.$validator.validateAll().then((result) => {
                    if(result) {
                        this.$startLoading()
                        if(this.data.id) {
                            this.update()
                        } else {
                            this.add()
                        }
                    }
                })

            },
            add(){
                coursesAPI.create(this.formData)
                    .then(response => {
                        this.submitRequest()
                        this.$notifySuccess(response.successMessage)
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
                    .finally(() => this.$closeLoading())
            },
            update(){
                coursesAPI.update(this.data.id, this.formData)
                    .then(response => {
                        this.submitRequest()
                        this.$notifySuccess(response.successMessage)
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
                    .finally(() => this.$closeLoading())
            },

            // this method calls when the request is success and delivered
            submitRequest(){
                this.$emit('submit', Object.assign({}, this.formData))
                this.close()
            },
            close(){
                this.$emit('update:active', false)
            },
            intiValues() {
                this.formData = {
                    id: '',
                    name: '',
                    description: '',
                }
                this.$validator.reset()
            },
        },
    }
</script>

<style scoped>

</style>
